import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  memo,
} from "react";
import { FaSearch, FaLink } from "react-icons/fa";
import "./CodeBook.css";
import bookOpenIcon from "../../assets/bookopen.png";
import booksIcon from "../../assets/books.png";
import bookInactiveIcon from "../../assets/booksinactive.png";
import achiIcon from "../../assets/achiinedx.png";
import indexIcon from "../../assets/Index.png";
import tabularicdIcon from "../../assets/icdtabular.png";
import australianIcon from "../../assets/austrilaincode.png";
import bookIcon from "../../assets/book.png";
import icd10amIcon from "../../assets/icd10am.png";
import starsIcon from "../../assets/starts.png";
import pako from "pako";
import { CodeContext } from "../pages/Coder/Coder";
import { useDebounce } from "use-debounce";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux"; // Import useSelector
import { Spinner } from "react-bootstrap";
import Bookopen from "../../common/assets/images/book-open-02 (1).png";
import LdsRoller from "../../utils/LdsRoller";
import { setOnChangeCodeBook, updateAcsCode } from "./redux/CodeBookSlicer";
import { green } from "@mui/material/colors";
// import AustralianCodebook from "./AustralianCodebook";
import USACodebook from "./USACodebook";
// import { ToggleSlider } from 'react-toggle-slider';
import ToggleButton from "./ToggleSlider";
import {
  fetchCodebookData,
  setActiveIcon,
  setActiveTab,
  setRawSearchQuery,
  setSearchByCodeId,
} from "./redux/CodeBookSlicer";

const CodeBookUsa = React.memo(({}) => {
  const dispatch = useDispatch();

  // const [activeIcon, setActiveIcon] = useState("ICD");
  // const [activeTab, setActiveTab] = useState("ICD 10 CM Index");
  const { selectedCodeDetails } = useSelector((state) => state.codeSearch);
  const { selectedCodeBookCode, selectedTabKeyCoding } =
    useContext(CodeContext);
  const [usePCSVersion, setUsePCSVersion] = useState(false);
  const lastCodedEpisode = useSelector((state) => state.episodeList);
  const typeOfPatient = lastCodedEpisode?.selectedEpisode?.type_patient;
  // console.log(selectedCodeDetails,"codebook")

  console.log(
    selectedCodeBookCode,
    selectedTabKeyCoding,
    " selectedTabKeyCoding"
  );
  const {
    icd10amTabularData,
    icd10amIndexData,
    achiIndexData,
    achiTabularData,
    pcsIndexData,
    pcsTabularData,
    isFetched12,
    codeBookLoading,
    codeBookError,
    activeTab,
    activeIcon,
    rawSearchQuery,
    searchByCodeId,
  } = useSelector((state) => state.codeBook);
  const [searchQuery, setSearchQuery] = useState("");
  const [droppedCodes, setDroppedCodes] = useState([]);
  // const [rawSearchQuery, setRawSearchQuery] = useState("");
  const [debouncedQuery] = useDebounce(rawSearchQuery, 300); // Debounce here
  // console.log( icd10amTabularData, " icd10amtabularData")
  // console.log(  icd10amIndexData, " icd10amIndexData")
  // console.log( achiIndexData,"achiindex");
  // console.log( achiTabularData,"achi tabular");
  // console.log(pcsIndexData,"pcsindex");
  // console.log( pcsTabularData,"pcstabular");

  useEffect(() => {
    if (!isFetched12) {
      dispatch(fetchCodebookData());
    }
  }, [isFetched12, dispatch]);
  const tabsConfig = useMemo(() => {
    return [
      { name: "ICD 10 CM Index", data: icd10amIndexData || [] },
      { name: "ICD 10 CM Tabular", data: icd10amTabularData || [] },
      { name: "PCS Index", data: pcsIndexData || [] },
      { name: "PCS Tabular", data: pcsTabularData || [] },
      { name: "CPT Tabular", data: achiTabularData || [] },
      { name: "CPT Index", data: achiIndexData || [] },
      { name: "American Coding Standard", data: [] },
    ];
  }, [
    icd10amIndexData,
    icd10amTabularData,
    achiTabularData,
    achiIndexData,
    pcsIndexData,
    pcsTabularData,
  ]);

  const getTabError = () => {
    if (!codeBookError) return null;
    switch (activeTab) {
      case "ICD 10 CM Tabular":
        return codeBookError.icd10amTabular
          ? `Failed to load ICD 10 CM Tabular data: ${codeBookError.icd10amTabular}`
          : null;
      case "ICD 10 CM Index":
        return codeBookError.icd10amIndex
          ? `Failed to load ICD 10 CM Index data: ${codeBookError.icd10amIndex}`
          : null;
      case "CPT Tabular":
        return codeBookError.achiTabular
          ? `Failed to load CPT Tabular data: ${codeBookError.achiTabular}`
          : null;
      case "CPT Index":
        return codeBookError.achiIndex
          ? `Failed to load CPT Index data: ${codeBookError.achiIndex}`
          : null;
      default:
        return null;
    }
  };

  const tabError = getTabError();
  // Update when patient type changes
  useEffect(() => {
    console.log(typeOfPatient,'typeOfPatientcodebook');
    
    if (typeOfPatient !== "outPatient") {
      // Inpatient
      setTimeout(()=>{

        dispatch(setActiveIcon("ICD"));
        dispatch(setActiveTab("ICD 10 CM Index"));
      },0)
    } else {

      // Outpatient
      setTimeout(()=>{

        dispatch(setActiveIcon("ICD"));
        dispatch(setActiveTab("PCS Index"));
      },0)
    }
  }, [typeOfPatient, dispatch]);
  useEffect(() => {
    const savedActiveTab = sessionStorage.getItem("activeTab");
    const savedActiveIcon = sessionStorage.getItem("activeIcon");

    if (savedActiveTab) {
      dispatch(setActiveTab(savedActiveTab)); // Set active tab if saved in sessionStorage
    }

    if (savedActiveIcon) {
      dispatch(setActiveIcon(savedActiveIcon)); // Set active icon if saved in sessionStorage
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("activeTab", activeTab); // Save active tab to sessionStorage
    sessionStorage.setItem("activeIcon", activeIcon); // Save active icon to sessionStorage
  }, [activeTab, activeIcon]);

  useEffect(() => {
    // --- Priority 1: CodeAssist search state ---
    if (selectedCodeDetails) {
      // setSelectedCodebookVersion("13th"); // force 13th

      const { category, code_id, value, isFromTabular } = selectedCodeDetails;
      setTimeout(() => {
        dispatch(setSearchByCodeId(code_id));
        dispatch(setRawSearchQuery(value));
      }, 0);
      if (category === "Additional Diagnoses") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 CM Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ICD 10 CM Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
      if (category === "Principal Diagnosis") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 CM Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ICD 10 CM Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
      if (category === "Procedure Codes" || category === "PCS Codes") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("PCS Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("PCS Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
    }
    // --- Priority 2: Normal flow ---
    if (selectedCodeBookCode && selectedTabKeyCoding) {
      // Reset Code ID (since we are searching by code value)
      dispatch(setSearchByCodeId(null));

      // Set the search query to the selected code
      dispatch(setRawSearchQuery(selectedCodeBookCode));

      // --- Handle Tab Activation Based on selectedTabKeyCoding ---

      if (selectedTabKeyCoding === "PCS") {
        // PCS → Go to PCS Tabular
        dispatch(setActiveIcon("Tabular"));
        dispatch(setActiveTab("PCS Tabular"));
      } else if (
        selectedTabKeyCoding === "CPT" ||
        selectedTabKeyCoding === "ACHI"
      ) {
        // CPT or ACHI → Go to CPT Tabular
        dispatch(setActiveIcon("Tabular"));
        dispatch(setActiveTab("CPT Tabular"));
      } else {
        // Default (ICD)
        dispatch(setActiveIcon("Tabular"));
        dispatch(setActiveTab("ICD 10 CM Tabular"));
      }
    } else {
      const { category} = selectedCodeDetails;
      // console.log(category,'category');
      
      // No selection → Reset state
      dispatch(setSearchByCodeId(null));
      dispatch(setRawSearchQuery(""));
    }
  }, [selectedCodeDetails, selectedCodeBookCode, selectedTabKeyCoding]);

  useEffect(() => {
    if (debouncedQuery?.length >= 2) {
      setSearchQuery(debouncedQuery);
    } else {
      setSearchQuery(""); // Clear if less than 3 chars
    }
  }, [debouncedQuery]); // debouncedQuery is the dependency

  const filterData = (items, query, codeId = null) => {
    // If we have a specific code ID to search for
    if (codeId) {
      const findByIdRecursive = (items, targetId) => {
        for (const item of items) {
          // Check if this item matches the target ID
          if (item.id === targetId) {
            return [item]; // Return only the matching item
          }

          // Check children recursively
          if (item.children) {
            const foundInChildren = findByIdRecursive(item.children, targetId);
            if (foundInChildren.length > 0) {
              // Return the parent with only the matching child
              return [
                {
                  ...item,
                  children: foundInChildren,
                  matches: true,
                },
              ];
            }
          }
        }
        return [];
      };

      return findByIdRecursive(items, codeId);
    }

    // Original text-based search (fallback)
    if (!query || query.length < 2) return items;

    const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : "";
    const results = [];
    const filterRecursive = (items) => {
      return items
        .map((item) => {
          const filteredChildren = item.children
            ? filterRecursive(item.children)
            : [];
          const matchesParent =
            (item.name && item.name.toLowerCase().includes(lowerCaseQuery)) ||
            (item.description &&
              item.description.toLowerCase().includes(lowerCaseQuery));

          const childrenToInclude = matchesParent
            ? item.children || []
            : filteredChildren;

          return {
            ...item,
            children: childrenToInclude,
            matches: matchesParent || childrenToInclude.length > 0,
          };
        })
        .filter((item) => item.matches || item.children?.length > 0);
    };

    return filterRecursive(items);
  };

  // const filteredDataMemo = useMemo(() => {
  //   const currentTabData = tabsConfig.find(
  //     (tab) => tab.name === activeTab
  //   )?.data;
  //   return filterData(currentTabData || [], searchQuery);
  // }, [activeTab, searchQuery, tabsConfig]);
  const filteredDataMemo = useMemo(() => {
    const currentTabData = tabsConfig.find(
      (tab) => tab.name === activeTab
    )?.data;

    return filterData(currentTabData || [], searchQuery, searchByCodeId);
  }, [activeTab, searchQuery, searchByCodeId, tabsConfig]);

  const handleSearchChange = (e) => {
    console.log("seeins", e.target.value);
    if (e.target.value) {
      dispatch(setOnChangeCodeBook(true));
    } else {
      dispatch(setOnChangeCodeBook(false));
    }

    const newValue = e.target.value;
    if (newValue !== rawSearchQuery) {
      dispatch(setRawSearchQuery(newValue));
      // dispatch(setSearchByCodeId(null))
      if (searchByCodeId) dispatch(setSearchByCodeId(null));
    }
    // console.log('onChangeCodeBook');
  };

  const handleIconClick = (icon) => {
    dispatch(setActiveIcon(icon));

    if (icon === "ICD") {
      if (typeOfPatient !== "outPatient") {
        dispatch(setActiveTab("ICD 10 CM Index"));
      } else {
        dispatch(setActiveTab("PCS Index"));
      }
    } else if (icon === "Tabular") {
      if (typeOfPatient !== "outPatient") {
        dispatch(setActiveTab("ICD 10 CM Tabular"));
      } else {
        dispatch(setActiveTab("CPT Tabular"));
      }
    } else if (icon === "Coding")
      dispatch(setActiveTab("American Coding Standard"));
  };

  const getIcon = (icon) => {
    if (icon === "ICD") {
      if (typeOfPatient !== "outPatient") {
        // Inpatient
        return activeTab === "ICD 10 CM Index"
          ? booksIcon
          : activeTab === "PCS Index"
          ? achiIcon
          : bookInactiveIcon;
      } else {
        // Outpatient
        return activeTab === "PCS Index" ? achiIcon : bookInactiveIcon;
      }
    }

    if (icon === "Tabular") {
      if (typeOfPatient !== "outPatient") {
        // Inpatient
        return activeTab === "ICD 10 CM Tabular"
          ? tabularicdIcon
          : activeTab === "PCS Tabular"
          ? icd10amIcon
          : bookInactiveIcon;
      } else {
        // Outpatient
        return activeTab === "CPT Tabular"
          ? tabularicdIcon
          : activeTab === "PCS Tabular"
          ? icd10amIcon
          : bookInactiveIcon;
      }
    }

    if (icon === "Coding") {
      return activeTab === "American Coding Standard"
        ? australianIcon
        : bookIcon;
    }

    return bookInactiveIcon;
  };

  const handleDrop = (code) => {
    setDroppedCodes((prev) => [...prev, code]);
  };

  const [displayedItems, setDisplayedItems] = useState([]); // Items to render
  const [loadMore, setLoadMore] = useState(50); // Number of items to load
  const searchResultsRef = React.useRef(null);

  useEffect(() => {
    setDisplayedItems(filteredDataMemo?.slice(0, loadMore));
  }, [filteredDataMemo, loadMore]);

  const handleScroll = useCallback(() => {
    if (!searchResultsRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = searchResultsRef.current;

    // If scrolled to the bottom, load 10 more items
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setLoadMore((prev) => prev + 10);
    }
  }, []);

  useEffect(() => {
    const element = searchResultsRef.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  return (
    <div className="codebook-container">
      <div className="codebook1-header">
        <span
          className={`header-navicon ${
            activeIcon === "ICD" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("ICD")}
        >
          <img src={getIcon("ICD")} alt="ICD Icon" width={30} height={30} />
        </span>
        <span
          className={`header-navicon ${
            activeIcon === "Tabular" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("Tabular")}
        >
          <img
            src={getIcon("Tabular")}
            alt="Tabular Icon"
            width={30}
            height={30}
          />
        </span>
        <span
          className={`header-navicon ${
            activeIcon === "Coding" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("Coding")}
        >
          <img
            src={getIcon("Coding")}
            alt="Coding Icon"
            width={30}
            height={30}
          />
        </span>
      </div>

      <div className="tabs-codes">
        {activeIcon === "ICD" && (
          <>
            {typeOfPatient !== "outPatient" && (
              <button
                className={activeTab === "ICD 10 CM Index" ? "active" : ""}
                style={{
                  borderBottomColor:
                    activeTab === "ICD 10 CM Index" ? "#FFE404" : "transparent",
                }}
                onClick={() => dispatch(setActiveTab("ICD 10 CM Index"))}
              >
                ICD 10 CM Index
              </button>
            )}
            <button
              className={activeTab === "PCS Index" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "PCS Index" ? "green" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("PCS Index"))}
            >
              PCS Index
            </button>
          </>
        )}
        {activeIcon === "Tabular" && (
          <>
            {typeOfPatient !== "outPatient" && (
              <button
                className={activeTab === "ICD 10 CM Tabular" ? "active" : ""}
                style={{
                  borderBottomColor:
                    activeTab === "ICD 10 CM Tabular" ? "red" : "transparent",
                }}
                onClick={() => dispatch(setActiveTab("ICD 10 CM Tabular"))}
              >
                ICD 10 CM Tabular
              </button>
            )}
            {typeOfPatient !== "outPatient" && (
              <button
                className={activeTab === "PCS Tabular" ? "active" : ""}
                style={{
                  borderBottomColor:
                    activeTab === "PCS Tabular" ? "blue" : "transparent",
                }}
                onClick={() => dispatch(setActiveTab("PCS Tabular"))}
              >
                PCS Tabular
              </button>
            )}

            {typeOfPatient === "outPatient" && (
              <>
                <button
                  className={activeTab === "CPT Tabular" ? "active" : ""}
                  style={{
                    borderBottomColor:
                      activeTab === "CPT Tabular" ? "red" : "transparent",
                  }}
                  onClick={() => dispatch(setActiveTab("CPT Tabular"))}
                >
                  CPT Tabular
                </button>
                <button
                  className={activeTab === "PCS Tabular" ? "active" : ""}
                  style={{
                    borderBottomColor:
                      activeTab === "PCS Tabular" ? "blue" : "transparent",
                  }}
                  onClick={() => dispatch(setActiveTab("PCS Tabular"))}
                >
                  PCS Tabular
                </button>
              </>
            )}
          </>
        )}
        {activeIcon === "Coding" && (
          <button
            className={activeTab === "American Coding Standard" ? "active" : ""}
            style={{ borderBottomColor: "purple" }}
          >
            American Coding Standards(ACS)
          </button>
        )}
      </div>

      {/* <div className="search-bar-code">
        <FaSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search by code or description"
          value={rawSearchQuery}
          onChange={handleSearchChange}
        />
 
      </div> */}
      {activeTab !== "American Coding Standard" && (
        <div className="search-bar-code">
          <FaSearch className="codebook-search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search by code or description"
            value={rawSearchQuery}
            onChange={handleSearchChange}
          />
        </div>
      )}

      <div className="search-results" ref={searchResultsRef}>
        {activeTab === "American Coding Standard" && <USACodebook />}

        <div className="accordion-container">
          {/* {
            codeBookLoading ? <div className="codebook-loader">
              <Spinner />{" "}
            </div> : <>
              {displayedItems.map((item,index) => (<AccordionItem key={index} item={item} searchQuery={searchQuery} activeTab={activeTab} />))}
            </>
          } */}
          {codeBookLoading ? (
            <div className="codebook-loader">
              <LdsRoller />
            </div>
          ) : (
            <>
              {displayedItems.length > 0
                ? displayedItems.map((item, index) => (
                    <AccordionItem
                      key={index}
                      item={item}
                      searchByCodeId={searchByCodeId}
                      searchQuery={searchQuery}
                      activeTab={activeTab}
                      isTopLevel={item.children.length === 0}
                      setActiveTab={setActiveTab}
                      dispatch={dispatch}
                      setActiveIcon={setActiveIcon}
                    />
                  ))
                : searchQuery.length >= 2 && <div>No matches found</div>}
            </>
          )}
        </div>

        {/* <div className="staricon">
            <img src={starsIcon} alt="Star Icon" />
        </div> */}
      </div>
    </div>
  );
});

const getItemCodes = (item, activeTab) => {
  const codeString = getItemCode(item, activeTab); // Get the combined code string
  if (!codeString) return []; // Handle cases where codeString is empty or null
  if (activeTab === "CPT Tabular" || activeTab === "CPT Index") {
    // ACHI: Return the entire string as one code, regardless of brackets.
    return [codeString];
  } else if (activeTab === "PCS Tabular" || activeTab === "PCS Index") {
    return codeString.length === 7 ? [codeString] : [];
  } else {
    // ICD: Split by common delimiters, but ONLY if they are OUTSIDE brackets.
    const delimiter = /[†* ,]+(?![^[]*\])/; // Split outside of brackets
    const codes = codeString
      .split(delimiter)
      .filter((code) => code.trim() !== "");
    return codes;
  }
};

const getItemCode = (item, activeTab) => {
  switch (activeTab) {
    case "ICD 10 CM Index":
    case "CPT Index":
    case "PCS Index":
      return item.description;
    case "ICD 10 CM Tabular":
    case "CPT Tabular":
    case "PCS Tabular":
    case "American Coding Standard":
      return item.name;
    default:
      return item.name;
  }
};
const highlightText = (text, query, onChangeCodeBook = false) => {
  // console.log(onChangeCodeBook,'cskdhsjdhgfsedf');

  if (!query || query.length < 2 || !text) {
    return text;
  }

  // Escape special regex characters
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // If onChangeCodeBook is true, do substring match; else exact match
  const regex = onChangeCodeBook
    ? new RegExp(escapedQuery, "i") // substring match
    : new RegExp(`^${escapedQuery}$`);

  if (regex.test(text)) {
    return <span className="highlighted">{text}</span>;
  }
  return text;
};
const handleDragStartLogic = (e, draggableCodes, activeTab) => {
  if (draggableCodes.length > 0) {
    const dragData = {
      codes: draggableCodes,
      tab: activeTab,
    };
    e.dataTransfer.setData("application/json", JSON.stringify(dragData));
    e.dataTransfer.setData("text/plain", JSON.stringify(draggableCodes));
    e.dataTransfer.setData(
      "text/uri-list",
      `data:text/plain;charset=utf-8,${encodeURIComponent(
        JSON.stringify(draggableCodes)
      )}`
    );
    // console.log("Dragging medical codes:", dragData.codes, "from tab:", dragData.tab);
  } else {
    e.preventDefault();
  }
};

const AccordionItem = ({
  item,
  activeTab,
  searchQuery,
  isTopLevel,
  searchByCodeId,
}) => {
  const { copiedCodes, setCopiedCodes } = useContext(CodeContext);
  const [isCopied, setIsCopied] = useState(false);
  const [localIsOpen, setLocalIsOpen] = useState(false);
  const { onChangeCodeBook } = useSelector((state) => state.codeBook);

  const isHighlightedById = searchByCodeId && item.id === searchByCodeId;
  useEffect(() => {
    if (searchByCodeId) {
      if (
        item.id === searchByCodeId ||
        (item.children &&
          item.children.some((child) => child.id === searchByCodeId))
      ) {
        setLocalIsOpen(true);
      }
    } else if (
      searchQuery.length > 1 &&
      item.children?.some((child) => child.matches)
    ) {
      setLocalIsOpen(true);
    } else if (searchQuery.length < 2) {
      setLocalIsOpen(false); // Close if no search or short query
    }
  }, [searchQuery, item.children]);
  useEffect(() => {
    if (searchQuery.length > 1) {
      // Check if the item or any of its descendants have matches
      const hasMatches =
        item.matches ||
        item.children?.some(
          (child) => child.matches || child.children?.some((c) => c.matches)
        );
      setLocalIsOpen(hasMatches);
    } else {
      setLocalIsOpen(false);
    }
  }, [searchQuery, searchByCodeId, item.children, item.id]);
  // useEffect(() => {
  //   if (
  //     searchQuery.length > 2 &&
  //     item.children?.some((child) => child.matches)
  //   ) {
  //     setLocalIsOpen(true); // Auto-open only if a child matches
  //   } else if (searchQuery.length < 3) {
  //     setLocalIsOpen(false); // Close if no search or short query
  //   }
  // }, [searchQuery, item.children]);
  useEffect(() => {
    if (searchQuery.length > 1) {
      // Check if the item or any of its descendants have matches
      const hasMatches =
        item.matches ||
        item.children?.some(
          (child) => child.matches || child.children?.some((c) => c.matches)
        );
      setLocalIsOpen(hasMatches);
    } else {
      setLocalIsOpen(false);
    }
  }, [searchQuery, item]);
  // useEffect(() => {
  //   if (searchQuery.length > 2) {
  //     // Check if the item or any of its descendants have matches
  //     const hasMatches = item.matches || (item.children?.some(child => child.matches || child.children?.some(c => c.matches)));
  //     setLocalIsOpen(hasMatches);
  //   } else {
  //     setLocalIsOpen(false);
  //   }
  // }, [searchQuery, item]);
  const toggleOpen = () => {
    setLocalIsOpen(!localIsOpen);
  };

  const codes = getItemCodes(item, activeTab);
  const draggableCodes = codes.filter((code) => {
    if (activeTab === "CPT Tabular" || activeTab === "CPT Index") {
      // return true;
      return !code.includes("-");
    } else if (activeTab === "PCS Tabular" || activeTab === "PCS Index") {
      return code.length === 7 && !code.includes("-"); // PCS: must be 7 characters and no hyphen
    } else {
      return !code.includes("-");
    }
  });

  const handleDragStart = useCallback(
    (e, draggableCodes) => {
      // console.log('Drag started with jyoti:', { draggableCodes, activeTab });
      handleDragStartLogic(e, draggableCodes, activeTab);
    },
    [activeTab]
  );

  const handleCopyCode = (e) => {
    if (
      (activeTab === "ICD 10 CM Tabular" ||
        activeTab === "CPT Tabular" ||
        activeTab === "PCS Tabular") &&
      (!item.children || item.children.length === 0)
    ) {
      // Tabular view logic
      if (draggableCodes.length > 0) {
        const codesString = draggableCodes.join(",");
        // console.log(codesString, "copy code========");
        navigator.clipboard
          .writeText(codesString)
          .then(() => {
            setIsCopied(true);
            setCopiedCodes(codesString.split(","));
            setTimeout(() => setIsCopied(false), 3000);
          })
          .catch((err) => {
            console.error("Clipboard copy error:", err); // Log the error for debugging
            if (err instanceof Error) {
              toast.error("Failed to copy: " + err.message);
            } else {
              toast.error("Failed to copy: An unknown error occurred.");
            }
          });
      }
    } else if (
      (activeTab === "ICD 10 CM Index" ||
        activeTab === "CPT  Index" ||
        activeTab === "PCS Index") &&
      draggableCodes.length > 0
    ) {
      // Index view logic
      const codesString = draggableCodes.join(",");
      // console.log(codesString, "copy code========");
      navigator.clipboard
        .writeText(codesString)
        .then(() => {
          setIsCopied(true);
          setCopiedCodes(codesString.split(","));
          setTimeout(() => setIsCopied(false), 3000);
        })
        .catch((err) => {
          // console.error("Clipboard copy error:", err); // Log the error for debugging
          if (err instanceof Error) {
            toast.error("Failed to copy: " + err.message);
          } else {
            toast.error("Failed to copy: An unknown error occurred.");
          }
        });
    }
  };
  // console.log(activeTab, 'activeTab');
useEffect(() => {
  return () => {
    toast.dismiss();
  };
}, []);
  return (
    <div className="codebook-wrapper accordion-item" key={"shbfsh"}>
      {isCopied && ( // Conditionally render the button
        <button className="code-copied-button">
          Code Copied <img src={Bookopen} alt="plus" />
        </button>
      )}
      <div className="accordion-header" onClick={toggleOpen}>
        <div className="header-content ">
          {item.children?.length > 0 && (
            <span className="accordion-icon">{localIsOpen ? "▼" : "▶"}</span>
          )}
          {/* <span
            onClick={handleCopyCode}
            draggable={activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular" && (!item.children || item.children.length === 0)}
            onDragStart={(activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular") && (!item.children || item.children.length === 0) ? (e) => handleDragStart(e, draggableCodes) : null}
            style={{
              color: (draggableCodes.length > 0 && (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular") && (!item.children || item.children.length === 0)) ? 'blue' : 'inherit',
              textDecoration: (draggableCodes.length > 0 && (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular") && (!item.children || item.children.length === 0)) ? 'underline' : 'none',
              fontWeight: isTopLevel || item.children?.length > 0 ? "bold" : "normal",

            }}
          >
            {highlightText(item.name, searchQuery)}

          </span> */}
          <span
            onClick={handleCopyCode}
            draggable={
              (activeTab === "ICD 10 CM Tabular" ||
                activeTab === "CPT Tabular" ||
                activeTab === "PCS Tabular") &&
              (!item.children || item.children.length === 0)
            }
            onDragStart={
              (activeTab === "ICD 10 CM Tabular" ||
                activeTab === "CPT Tabular" ||
                activeTab === "PCS Tabular") &&
              (!item.children || item.children.length === 0)
                ? (e) => handleDragStart(e, draggableCodes)
                : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 CM Tabular" ||
                  activeTab === "CPT Tabular" ||
                  activeTab === "PCS Tabular") &&
                (!item.children || item.children.length === 0)
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 CM Tabular" ||
                  activeTab === "CPT Tabular" ||
                  activeTab === "PCS Tabular") &&
                (!item.children || item.children.length === 0)
                  ? "underline"
                  : "none",
              fontWeight:
                isTopLevel || item.children?.length > 0 ? "bold" : "normal",
            }}
          >
            {highlightText(item.name, searchQuery, onChangeCodeBook)}
          </span>

          {/* <span

            className="item-description"
            onClick={handleCopyCode}
            draggable={
              (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular")
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              (activeTab === "ICD 10 CM Tabular" || activeTab === "CPT Tabular")
                ? null
                : draggableCodes.length > 0
                  ? (e) => handleDragStart(e, draggableCodes)
                  : null
            }
            style={{
              color: draggableCodes.length > 0 && (activeTab === "ICD 10 CM Index" || activeTab === "CPT Index") ? 'blue' : 'inherit',
              textDecoration: draggableCodes.length > 0 && (activeTab === "ICD 10 CM Index" || activeTab === "CPT Index") ? 'underline' : 'none',
            }}
          >
            <span className="item-descrpition-value">{highlightText(item.description, searchQuery)}</span>

          </span> */}
          <span
            className="item-description"
            onClick={handleCopyCode}
            draggable={
              activeTab === "ICD 10 CM Tabular" ||
              activeTab === "CPT Tabular" ||
              activeTab === "PCS Tabular"
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              activeTab === "ICD 10 CM Tabular" ||
              activeTab === "CPT Tabular" ||
              activeTab === "PCS Tabular"
                ? null
                : draggableCodes.length > 0
                ? (e) => handleDragStart(e, draggableCodes)
                : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 CM Index" ||
                  activeTab === "CPT Index" ||
                  activeTab === "PCS Index")
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 CM Index" ||
                  activeTab === "CPT Index" ||
                  activeTab === "PCS Index")
                  ? "underline"
                  : "none",
            }}
          >
            <span className="item-descrpition-value">
              {highlightText(item.description, searchQuery, onChangeCodeBook)}
            </span>
          </span>
          {item.see && (
            <span className="font_purple">
              {" "}
              see – {highlightText(item.see.replace(/^�\s*/, ""), searchQuery)}
            </span>
          )}
          {item.seealso && (
            <span className="font_orange">
              {" "}
              seealso –{" "}
              {highlightText(item.seealso.replace(/^�\s*/, ""), searchQuery)}
            </span>
          )}
          {item.inclusion && localIsOpen && (
            <div className="font_green">
              <b>Includes</b> : {highlightText(item.inclusion, searchQuery)}
            </div>
          )}
          {item.useAdditional && localIsOpen && (
            <div className="font_blud">
              <b>useAdditional</b> :{" "}
              {highlightText(item.useAdditional, searchQuery)}
            </div>
          )}
          {item.exclusion && localIsOpen && (
            <div className="font_red">
              <b>Excludes</b> : {highlightText(item.exclusion, searchQuery)}
            </div>
          )}
          {item.definition && localIsOpen && (
            <div className="font_pink">
              <b>Definition</b> : {highlightText(item.definition, searchQuery)}
            </div>
          )}
          {item.note && localIsOpen && (
            <div className="font_yellow">
              <b>Note</b> : {highlightText(item.note, searchQuery)}
            </div>
          )}
          {item.stylednote && localIsOpen && (
            <div className="font_blue">
              <b>Stylednote</b> : {highlightText(item.stylednote, searchQuery)}
            </div>
          )}
        </div>
      </div>
      {localIsOpen && item.children?.length > 0 && (
        <div className="accordion-children">
          {item.children.map((child) => (
            <AccordionItem
              key={child.id}
              item={child}
              activeTab={activeTab}
              searchByCodeId={searchByCodeId}
              searchQuery={searchQuery}
              setActiveTab={setActiveTab}
              setActiveIcon={setActiveIcon}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(CodeBookUsa);
